// Hover/click halos for timeline trigger pies. Event layers share one z-index, so a halo that
// reaches a neighbouring circle would win hit-testing there whatever the paint order; each halo
// therefore stops short of every other circle, but never below its own pie's radius.

/** Uncapped halo radius as a multiple of the pie's radius (the historical 4r × 4r wrapper). */
export const HALO_FACTOR = 2;

/**
 * Halo radius per node, capped so no halo reaches into another node's circle.
 *
 * @param {{ x: number, y: number, r: number }[]} nodes circle centres + radii, one row's worth
 * @returns {number[]} halo radius per node, in input order
 */
export function haloRadii(nodes) {
  return nodes.map((n, i) => {
    let h = HALO_FACTOR * n.r;
    for (let j = 0; j < nodes.length; j++) {
      if (j === i) continue;
      const o = nodes[j];
      const gap = Math.hypot(o.x - n.x, o.y - n.y) - o.r;
      if (gap < h) h = gap;
    }
    return Math.max(n.r, h);
  });
}

/**
 * The hit wrapper's box for a pie of radius `r` whose circle's top edge is at `circleY`,
 * relative to the event layer (whose x origin is the pie's centre). `inset` places the pie
 * inside the wrapper so the circle stays centred on it. `haloR` nullish → the uncapped halo.
 *
 * @param {number} r
 * @param {number} circleY
 * @param {number|null|undefined} haloR
 * @returns {{ left: number, top: number, size: number, inset: number }}
 */
export function haloBox(r, circleY, haloR) {
  const h = haloR ?? HALO_FACTOR * r;
  return { left: -h, top: circleY + r - h, size: 2 * h, inset: h - r };
}
